<template>

    <div class="website::admin-WebsitePageSelector" :class="{ loading: websiteMenuPages === null }">

        <div class="absolute mt-2 ml-3 z-10" v-if="websiteMenuPages === null">

            <HalfCircleSpinner
                :size="20"
                color="#ddd"/>

        </div>

        <treeselect
            ref="treeselect"
            :value="internalValue"
            :options="treeOptions"
            clearAllText="Verwijder allemaal"
            clearValueText="Verwijder"
            loadingText="Laden.."
            noChildrenText="Geen pagina's"
            noOptionsText="Geen keuzes.."
            noResultsText="Geen keuzes.."
            placeholder="Kies pagina.."
            retryText="Probeer opnieuw"
            searchPromptText="Typ om te zoeken"
            :closeOnSelect="false"
            @input="onInput($event)">

            <template slot="option-label" slot-scope="{ node }">

                <div
                    v-if="node.raw.type === 'menu'"
                    class="text-sm"
                    :class="{
                            'font-bold': bold = value && selectedParents.indexOf('websiteMenu-' + node.raw.websiteMenu.id) !== -1,
                            'py-1': true,
                        }"
                    :style="{ fontWeight: !bold ? 'normal !important' : '' }"
                    @click="onMenuClick">{{ node.raw.name }} menu
                </div>

                <div
                    v-else
                    :class="{
                            'bg-none': true,
                            'text-sm': true,
                            'text-blue-400': node.raw.websiteMenuPage.website_page.id === value,
                            'font-bold': node.raw.websiteMenuPage.website_page.id === value || selectedParents.indexOf('websitePage-' + node.raw.websiteMenuPage.website_page.id) !== -1,
                        }">{{ node.raw.title }}
                </div>

            </template>

            <div slot="value-label" slot-scope="{ node }">{{ node.raw.title }}</div>

        </treeselect>

    </div>

</template>

<script>

import axios from '@galaxy/modules/Core/resources/js/axiosBuilder';
import {HalfCircleSpinner} from 'epic-spinners';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {

    components: {
        HalfCircleSpinner,
        Treeselect,
    },

    props: {
        value: Number,

        // Needed for CKEditor plugin.
        initialValueLink: String,
        language: String,
    },

    data() {
        return {
            internalValue: null,
            websiteMenuPages: null,
            websitePageId2internalId: {},
            id2websiteMenuPage: {},
            selectedParents: [],
        };
    },

    async mounted() {
        await this.loadData();

        this.initInitialValueLink();
    },

    methods: {

        async loadData() {
            // Load artists.
            this.websiteMenuPages = (await axios.get('/admin/canvas-editor/inputs/website-page/data')).data;
        },

        // @ugly Using jQuery to hack this plugin.
        onMenuClick(event) {
            // Get node id.
            let nodeId = $(event.currentTarget).parent().parent().data('id');

            // Get node.
            let node = this.$refs['treeselect'].forest.nodeMap[nodeId];

            // Toggle due to having children?
            if (node.children)
                this.$refs['treeselect'].toggleExpanded(node);
        },

        initInitialValueLink() {
            // Abort due to not present?
            if (!this.initialValueLink)
                return;

            // Find website page.
            let websiteMenuPage = _.find(Object.values(this.id2websiteMenuPage), websiteMenuPage => '/' + websiteMenuPage.website_page.slug[this.language] == this.initialValueLink);

            // Emit new value?
            if (websiteMenuPage)
                this.$emit('update:value', websiteMenuPage.website_page.id);
        },

        onInput(value) {
            // Abort due to is opening menu?
            if (value && value.includes('menu_') && !value.includes('_websitePage-'))
                return;

            // Extract website page id?
            if (value) {
                /*
                // Open menu?
                if(value && value.includes('menu_') && !value.includes('_websitePage-'))
                {
                    let node = this.$refs['treeselect'].forest.nodeMap[value];

                    console.info({ node });

                    this.$refs['treeselect'].toggleExpanded(node);

                    // Avoid selecting value.
                    return;
                }
                */

                // Clear due to no menu is selected?
                if (!value.includes('-'))
                    value = undefined;

                // Get id from website page item?
                else
                    value = parseInt(value.split('_websitePage-').pop());
            }
            // Clear value due to none selected?
            else if (value === 0)
                value = undefined;

            // Update value?
            if (this.value !== value) {
                // Close?
                if (value)
                    this.$refs['treeselect'].closeMenu();

                // Emit new value.
                this.$emit('update:value', value);
            }
        },

        mapItem(websiteMenu, websiteMenuPages, parentIds = []) {
            // Abort due to no items? Otherwise Treeselect will show empty subtree.
            if (!websiteMenuPages.length)
                return undefined;

            // Map items.
            return _.map(websiteMenuPages, websiteMenuPage => {
                // Map in internal id - to support non-unique items.
                let internalId = 'menu-' + websiteMenu.id + '_websitePage-' + websiteMenuPage.website_page.id;

                this.websitePageId2internalId[websiteMenuPage.website_page.id] = internalId;

                // Set url.
                this.id2websiteMenuPage[websiteMenuPage.id] = websiteMenuPage;

                // Add as selected parent?
                if (this.value == websiteMenuPage.website_page.id)
                    this.selectedParents.push(...parentIds);

                // Get title.
                let title = websiteMenuPage.website_page.title_menu?.[this.language] || websiteMenuPage.website_page.title_page?.[this.language];

                // Map
                return {
                    id: internalId,
                    websiteMenuPage,
                    type: 'websiteMenuPage',
                    title,
                    label: title, // To support search.
                    children: this.mapItem(
                        websiteMenu,
                        websiteMenuPage.children,
                        [].concat(parentIds, ['websitePage-' + websiteMenuPage.website_page.id])
                    ),
                };
            });
        },

    },

    computed: {

        treeOptions() {
            // Abort due to empty?
            if (this.websiteMenuPages === null)
                return [];

                    this.selectedParents = [];
            this.id2websiteMenuPage = {};
            this.websitePageId2internalId = {};

            // Map website pages.
            let result = _.map(this.websiteMenuPages, websiteMenu => {
                return {
                    id: 'menu_' + websiteMenu.id,
                    websiteMenu,
                    type: 'menu',
                    name: websiteMenu.name,
                    children: this.mapItem(websiteMenu, websiteMenu.website_menu_pages, ['websiteMenu-' + websiteMenu.id]),
                };
            });

            // Set internal value by internal ids.
            this.internalValue = this.websitePageId2internalId[this.value] || null;

                    return result;
        },

        selectedWebsitePage() {
            if (this.value)
                return this.id2websiteMenuPage[this.value].website_page;
        }

    },

}

</script>

<style lang="scss" scoped>

.website\:\:admin-WebsitePageSelector {

    &.loading {

        .vue-treeselect {
            pointer-events: none;
        }

        ::v-deep .vue-treeselect__placeholder {
            padding-left: 33px !important;
        }

    }

    ::v-deep {

        .vue-treeselect__single-value,
        .vue-treeselect__placeholder {
            @apply px-2 items-center;

            &:not(.vue-treeselect-helper-hide) {
                @apply inline-flex
            }
        }

        .vue-treeselect__single-value,
        .vue-treeselect__placeholder,
        input {
            @apply text-sm;
            box-shadow: none;
            color: #333 !important;
        }

        .vue-treeselect__option--selected {
            background: white !important;
        }

        .vue-treeselect__control {
            @apply border border-gray-300;
            height: 38px;
        }

        .vue-treeselect__menu {
            top: 100%;
            bottom: auto;
        }

    }

}

</style>
